import React from "react";
import Logo from "./img/logo-white.svg";

export default function Footer() {
    return (
        <div className="footer footer_black footer_nomarg">
            <div className="footer__bottom">
                <div className="footer__inner inner-xs">
                    <div className="footer__topic">
                        <div className="footer__logo">
                            <a href="/" className="logo">
                                {/* <img src={Logo} alt="logo" /> */}
                            </a>
                        </div>
                        <div className="footer__info footer__info_mod">&copy; «glavnoe.life», 2010 - 2021</div>
                    </div>
                    <div className="footer__copy footer__copy_sm text-center">
                        <p>
                            Использование материалов, авторские права на которые принадлежат сторонним ресурсам,
                            возможно только с прямой активной ссылкой на первоисточник.
                        </p>
                        <p>
                            Редакция не несет ответственности за достоверность информации, содержащейся в рекламных
                            объявлениях. Категория интернет-ресурса 18+
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
